export default "/static/9ee409ac4c23ea83.svg"